import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { getEigenWeek } from '../work-quality.api';
import type { EigenWeekAntwoord } from '../work-quality.api';

export interface EigenWeekLezing {
  data?: EigenWeekAntwoord;
  isLoading: boolean;
  isError: boolean;
  /** De pagina is geweigerd (403): geen storing van de meting, en het scherm zegt dat ook zo. */
  isGeweigerd?: boolean;
  refetch: () => void;
}

/**
 * De eigen week ophalen. Eén aanroep, één meting, geen terugval op een oudere week.
 *
 * Geen `refetchInterval` en geen verversing bij vensterfocus: een meetwaarde die vanzelf verspringt
 * suggereert beweging waar meting hoort (`EXPERIENCE.md`, *Interaction Primitives*). Een storing
 * blijft een storing — er is geen stille cache die er een lege week van maakt (AD-27).
 */
export function useOwnWeek(week: string): EigenWeekLezing {
  const query = useQuery({
    queryKey: ['workQuality', 'me', week],
    queryFn: () => getEigenWeek(week),
    enabled: week !== '',
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    isGeweigerd: isAxiosError(query.error) && query.error.response?.status === 403,
    refetch: () => {
      void query.refetch();
    },
  };
}
